import { render } from "./bon-livraison-modal.vue?vue&type=template&id=38fcac4f"
import script from "./bon-livraison-modal.vue?vue&type=script&lang=js"
export * from "./bon-livraison-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__